// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1BjTp","Form":"Auth_Form__zklW-","Error":"Auth_Error__ihDim","Button":"Auth_Button__3Y4xT","Switch":"Auth_Switch__2MHr_","Link":"Auth_Link__1G2UA"};